import { theme } from 'antd';

import type { ThemeConfig } from 'antd';

export const darkTheme: ThemeConfig = {
  algorithm: [theme.darkAlgorithm],
  token: {
    colorPrimary: '#fb9318',
    colorText: '#cccad7',
    colorWarning: '#bd363b',
    colorError: '#bd363b',
    colorTextPlaceholder: '#9e9e9e',
    fontFamily: 'Lato',
    zIndexPopupBase: 3000,
  },
  components: {
    Table: {
      borderColor: '#353344',
      headerBg: '#0d0d0d',
      fontSize: 14,
      selectionColumnWidth: 10,
    },
    Slider: {
      trackBg: '#fb9318',
      trackHoverBg: '#fb9318',
      handleColor: '#fb9318',
      handleActiveColor: '#fb9318',
    },
  },
};
